import { render, staticRenderFns } from "./QiscusAcquisitionAnnouncementComponent.vue?vue&type=template&id=1f423201&scoped=true&"
import script from "./QiscusAcquisitionAnnouncementComponent.vue?vue&type=script&lang=ts&"
export * from "./QiscusAcquisitionAnnouncementComponent.vue?vue&type=script&lang=ts&"
import style0 from "./QiscusAcquisitionAnnouncementComponent.vue?vue&type=style&index=0&id=1f423201&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f423201",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDialog,VDivider,VIcon,VSpacer})
